import React from 'react'
import { OrdersIcon } from './orders'
import { TemplatesIcon } from './templates'
import { RulerIcon } from './rules'
import { CompaniesIcon } from './companies'
import { UsersIcon } from './users'
import { LogoutIcon } from './logout'
import { SidebarIcon } from './sidebar'
import { LogoIcon } from './logo'
import { LogoShortIcon } from './logoShort'
import { FilterIcon } from './Filter'
import { DownloadIcon } from './download'
import { BriefIcon } from './briefcase'
import { CheckIcon } from './Check'
import { CloseIcon } from './Close'

export const iconMap: Record<string, React.FC<{ className?: string }>> = {
    orders: OrdersIcon,
    template: TemplatesIcon,
    rules: RulerIcon,
    companies: CompaniesIcon,
    user: UsersIcon,
    logout: LogoutIcon,
    sidebar: SidebarIcon,
    logo: LogoIcon,
    short: LogoShortIcon,
    filter: FilterIcon,
    download: DownloadIcon,
    briefcase: BriefIcon,
    check: CheckIcon,
    close: CloseIcon
}

export const DynamicIcon: React.FC<{
    name: string
    className?: string
    onClick?: () => void
}> = ({ name, className = '' }) => {
    const IconComponent = iconMap[name.toLowerCase()]

    if (!IconComponent) {
        console.warn(`Icon "${name}" not found in iconMap`)
        return null
    }

    return <IconComponent className={className} />
}
